import React, { useState } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';

import ActionLink from '../builder/ActionLink';
import { useOwner } from '../context/context.js';
import { ProfileModule } from '../ui_items/Module.js';
import FloatingLayer from '../builder/FloatingLayer.js';
import SinglePromoInsight from '../insights/SinglePromoInsight.js';

const PromoExceededs = (props) => {
	const owner = useOwner();

	const [display_layer, setDisplayLayer] = useState(false);

	const promotion = owner?.promotion?.Promotion ?? false;
	if(promotion === false) return null;
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	
	let default_rate_limit;
	switch(parseInt(promotion.promo_type)) {
		case 2:
			default_rate_limit = 300;
			break;
		case 1:
			default_rate_limit = 150;
			break;
		case 0:
		default:
			default_rate_limit = 50;
			break;
	}

	const rate_limit = promotion?.rate_limit ?? default_rate_limit;

	return (
		<ProfileModule _class={{ padding:false, other:'gui_hidden_overflowed' }}>
			<header class="module_header whiteColor redBg empty_contents in_top" style={{ border:'none' }}>
				<h2 class="h knk-heavy-loaded">{i18n("Waiting Page enabled")}</h2>
			</header>

			<div class="gui_is_padded gui_padded_in_top">
				<p class="gui_not_in_bottom_tiny"><strong><FormattedMessage id="Wow! Your promotion is thriving and has reached its concurrency limit for a brief period: {rate_limit} requests per minute." values={{rate_limit}} /></strong></p>

				<p class="gui_not_in_bottom_tiny">{i18n("When you exceed this limit, new users are directed to a waiting page before gaining access to the promotion.")}</p>

				<p>
					<ActionLink
						onClick={() => setDisplayLayer(true)}
						_target="_blank"
						icon='knk-arrow-r-big gui_small_icon'
					>Check stats of the waiting page</ActionLink>
				</p>

				{/*<p><ActionLink _target="_blank" _href={`${window.zendesk_base_url}111`}>Learn more about concurrency limits.</ActionLink></p>
				<p><ActionLink _target="_blank" _href={`${window.zendesk_base_url}222`}>How to customize the waiting page.</ActionLink></p>*/}
			</div>

			{(display_layer) && (
				<FloatingLayer _class={{size:'fullscreen'}} backButton={() => setDisplayLayer(false)}>
					<div class="without_actions">
						<SinglePromoInsight
							type="exceeded"
							promotion={promotion}
							active={{
								key:'exceededs',
								icon:'knk-heavy-loaded',
								title:"Waiting Page",
								link_type:'link',
								// unit:'hour',
							}}
							intl={props.intl}
						/>
					</div>
				</FloatingLayer>
			)}
		</ProfileModule>
		
	);
}

export default injectIntl(PromoExceededs);